export const orderArrayByOrden = (list) => {
    if (list && list.length > 0) {
        return list.slice().sort((a, b) => a.orden - b.orden);
    }
    return list;
};
